import DocumentEnterpriseComponent from "./ec/impl/Docs/DocumentEnterpriseComponent";

// The browser-side EnterpriseComponent classes this app can build by name.
//
// The factory appends "EnterpriseComponent" to what it is asked for, so makeEnterpriseComponent
// ("Document") resolves the entry below. An unregistered name returns undefined and the grid
// renders nothing -- with no error -- so a component added without a line here looks like an empty
// table rather than a mistake.
const enterpriseComponentClasses: Map<string, object> = new Map();

enterpriseComponentClasses.set("DocumentEnterpriseComponent", DocumentEnterpriseComponent);

export default function enterpriseComponentClassFactory(name: string): object | undefined{
    return enterpriseComponentClasses.get(name + "EnterpriseComponent");
}
